//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionNavigate from "../../transitions/Navigate.vue";
import SearchLoader from "../loader/Loader.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
  name: "BlueResults",
  components: { TransitionNavigate, SearchLoader, Item },
  props: [],
  data() {
    return {};
  },
  computed: {
    results() {
      return this.$store.getters.results.itemResults;
    },
    reloading() {
      if (this.config.transitionOnReload) return this.$store.getters.reloading;
      else return false
    },
  },
  methods: {
    formatDate(date, formatPattern) {
      return format(new Date(date), formatPattern);
    },
  },
  watch: {},
};
